var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"w-full table-auto border-separate border-spacing-0"},[_c('thead',[_vm._t("header")],2),_vm._v(" "),_c('tbody',[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }